import styled, { css } from 'styled-components';
import { hideConfirm, showConfirm, useConfirmSliceSelector } from '../../store/modules/confirm';
import Blanket from '../common/Blanket';
import Button from '../common/Button';
import closeBtnImg from '../../img/dlg-close.png';
import { cssFloatRight } from '../common/CssCommon';
import { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 322px;
  background-color: white;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  border: 1px solid #b1b6bb;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.4);
`;

const Header = styled.div`
  height: 48px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px;
  box-sizing: border-box;
`;

const CloseBtn = styled.div`
  width: 24px;
  height: 24px;
  ${cssFloatRight}
  cursor:pointer;
`;

const Contents = styled.div`
  padding: 0 20px 10px 20px;
  color: #2f3133;
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  /* word-break: keep-all; */
`;

const ButtonArea = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 10px 8px 18px 0px;
`;

const ButtonCss = css`
  width: 81px;
  height: 30px;
  margin-right: 12px;
`;

const HeaderTitle = styled.div`
  flex: 1;
  padding-left: 2px;
  font-size: 15px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

export default function Confirm() {
  const confirmSelector = useConfirmSliceSelector();
  const dispatch = useDispatch();
  const hide = () => {
    dispatch(hideConfirm());
  };
  const callFuncAndHide = (callback) => {
    if (callback) callback();
    hide();
  };
  if (!confirmSelector.isShow) return null;
  return (
    <Blanket>
      <Wrapper>
        <Header>
          <HeaderTitle>{confirmSelector.title}</HeaderTitle>
          {confirmSelector.showCloseBtn && (
            <CloseBtn
              onClick={() => {
                hide();
              }}>
              <img src={closeBtnImg} alt="Close Button"></img>
            </CloseBtn>
          )}
        </Header>
        <Contents>
          {confirmSelector.msg.split('\n').map((line, index) => (
            <Fragment key={index}>
              {line}
              <br />
            </Fragment>
          ))}
        </Contents>
        <ButtonArea>
          <Button
            autoFocus
            onClick={() => {
              callFuncAndHide(confirmSelector.btn.confirm.callback);
            }}
            primary={true}
            cssExt={ButtonCss}>
            {confirmSelector.btn.confirm.text}
          </Button>
          <Button
            onClick={() => {
              callFuncAndHide(confirmSelector.btn.cancel.callback);
            }}
            cssExt={ButtonCss}>
            {confirmSelector.btn.cancel.text}
          </Button>
        </ButtonArea>
      </Wrapper>
    </Blanket>
  );
}

export function useGenConfirmPromise() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  return function ({ title, message, btn }) {
    return new Promise((resolve, reject) => {
      dispatch(
        showConfirm({
          title,
          msg: message,
          showCloseBtn: true,
          btn: {
            confirm: {
              text: btn?.confirm?.text || i18n.t('Common.Yes'),
              callback: () => {
                resolve(true);
              }
            },
            cancel: {
              text: btn?.cancel?.text || i18n.t('Common.No'),
              callback: () => {
                resolve(false);
              }
            }
          }
        })
      );
    });
  };
}
